<div class="modal-header">
    <h4 class="modal-title pull-left">Activity Log Detail</h4>
    <button aria-label="Close" class="close pull-right" (click)="modalRef.hide()" type="button">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="clearfix"></div>
</div>
<div class="modal-body">
    <div class="view-audit-trail clearfix">
        <ul class="rightside-details" *ngIf="auditTrailDetailModel?.length != 0 && !showNoChangeText">
            <li class="clearfix" *ngFor="let item of auditTrailDetailModel;">
                <p class="labelname">{{item.FieldName}}</p>
                <div class="floatleftdiv clearfix">
                    <p class="newdata">{{item.ChangedValue}}</p>
                    <p class="olddata">{{item.PreviousValue}}</p>
                </div>
            </li>
        </ul>
        <ul class="rightside-details" *ngIf="auditTrailDetailModel?.length == 0 && !showNoChangeText">
            <li class="clearfix">
                Details are being extracted. Please wait...
            </li>
        </ul>
        <ul class="rightside-details" *ngIf="showNoChangeText">
            <li class="clearfix">
                No Change in data.
            </li>
        </ul>
    </div>
    <div class="text-right margin-top-20">
        <button class="btn btn-default btn-lg" (click)="modalRef.hide()">OK</button>
    </div>
</div>